import TR from 'utils/TR';
import T from 'utils/T';
import ex from 'utils/ex';
import FocusableButton from 'components/common/FocusableButton';

export default function Check(props) {
  const {
    checked,
    children,
    ...rest
  } = props || {};
  return (
    <FocusableButton {...ex(['Check', { checked }], rest)}>
      <svg width={17} height={16} viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.928467 4C0.928467 2.067 2.49547 0.5 4.42847 0.5H12.4285C14.3615 0.5 15.9285 2.067 15.9285 4V12C15.9285 13.933 14.3615 15.5 12.4285 15.5H4.42847C2.49547 15.5 0.928467 13.933 0.928467 12V4Z" />
        <path d="M7.22847 10.3L5.12847 8.2L4.42847 8.9L7.22847 11.7L13.2285 5.7L12.5285 5L7.22847 10.3Z" />
      </svg>
      {children}
    </FocusableButton>
  );
}

